import type {
  FetchBody,
  FetchHttpMethod,
} from './types';

export function joinFetchUrl(baseUrl: string, route: string): string {
  if (!route) return baseUrl;
  const routeSuffix = route.startsWith('?')
    || route.startsWith('&')
    || route.startsWith('/')
    ? route
    : `/${route}`;
  return `${baseUrl}${routeSuffix}`;
}

export function createFetchCacheKey(
  url: string,
  method: string,
  serializedBody = ''
): string {
  return Object.entries({
    url,
    method,
    body: serializedBody,
  })
    .map(([key, value]) => `${key}:${value}`)
    .join('||');
}

const serializeFetchCacheBody = (body: FetchBody | undefined): string => {
  if (body === undefined) {
    return '';
  }
  if (typeof FormData !== 'undefined' &&
    body instanceof FormData) {
    return String(body);
  }
  if (typeof URLSearchParams !== 'undefined' &&
    body instanceof URLSearchParams) {
    return String(body);
  }
  return JSON.stringify(body);
};

export function createFetchRequestCacheKey(
  baseUrl: string,
  method: FetchHttpMethod,
  route = '',
  body?: FetchBody
): string {
  return createFetchCacheKey(
    joinFetchUrl(baseUrl, route),
    method,
    serializeFetchCacheBody(body)
  );
}

export function makeAbsoluteUrl(url: string): string {
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  return new URL(url, window.location.href).href;
}

export function getUrlPathname(url: string): string | null {
  try {
    return new URL(url).pathname;
  } catch (error) {
    return null;
  }
}
